<template>
  <span
    class="tc-source-badge"
    :class="[`tc-source-badge--${meta.cssKey}`, variant === 'labeled' ? 'tc-source-badge--labeled' : 'tc-source-badge--compact']"
    :title="meta.label"
    :aria-label="meta.label"
  >
    <span class="tc-source-badge-tile">{{ meta.letter }}</span>
    <span v-if="variant === 'labeled'" class="tc-source-badge-label">{{ meta.label }}</span>
  </span>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { SOURCE_META, type SourceMeta } from '../../connectors/registry';
import type { SourceId } from '../../api/calendar';

const props = defineProps<{
  source: SourceId;
  variant?: 'compact' | 'labeled';
}>();

// Defensive fallback for a source id with no registry entry (or missing
// entirely, e.g. an older fixture/payload without a `source` field) — renders
// a "?" tile instead of throwing on an undefined source.
const meta = computed<SourceMeta>(() => SOURCE_META[props.source] ?? {
  id: props.source ?? 'unknown',
  label: props.source ?? 'Unknown',
  letter: props.source?.[0]?.toUpperCase() ?? '?',
  cssKey: props.source ?? 'unknown',
});
</script>
